import React, { useEffect } from 'react';
import useAccessibleDialog from '../../hooks/useAccessibleDialog';
import './DistributorEntryDialog.css';

// Match the client-side entry modals while keeping distributor forms and their contracts intact.
export default function DistributorEntryDialog({
  open,
  title,
  locked = false,
  onClose,
  children,
  t,
}) {
  const { dialogRef, titleId } = useAccessibleDialog({ open, onClose, closeDisabled: locked });
  useEffect(() => {
    if (!open) return undefined;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
    };
  }, [open]);
  return (
    <div hidden={!open} className="me-dw-entry-overlay">
      <div
        className="me-dw-entry-backdrop"
        onClick={() => !locked && onClose()}
        aria-hidden="true"
      />
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        className="me-dw-entry-dialog"
      >
        <header className="me-dw-entry-heading">
          <h2 id={titleId}>{t(title)}</h2>
          <button type="button" aria-label={t('Close')} onClick={onClose} disabled={locked}>
            <span className="material-symbols-outlined" aria-hidden="true">
              cancel
            </span>
          </button>
        </header>
        <div className="me-dw-entry-body">{children}</div>
      </div>
    </div>
  );
}
